import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { PROVIDER_LABELS } from 'Pods/ThreeDStudio/Shared/AIEngineSelector/providerLabels'
import ClosedButtonSettings from 'Pods/ThreeDStudio/Shared/ClosedButtonSettings/ClosedButtonSettings'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

function CollapsedAIEngineRow() {
  const t = useTranslation()
  const generationProvider = useThreeDStudioStore(state => state.schema.generationProvider)
  const availableGenerationProviders = useThreeDStudioStore(
    state => state.schema.availableGenerationProviders,
  )

  const buttonLabel = PROVIDER_LABELS[generationProvider] || ''
  const isActive = Boolean(generationProvider)
  // Treat unloaded schema (availableGenerationProviders === undefined) as "not yet known",
  // not as disabled. Only mark disabled once the list is loaded and excludes the provider.
  const disabled = Array.isArray(availableGenerationProviders)
    && !availableGenerationProviders.includes(generationProvider)

  return (
    <ClosedButtonSettings
      label={t('leftSide.aiEngine.label')}
      isActive={isActive}
      disabled={disabled}
      buttonLabel={buttonLabel}
    />
  )
}

export default memo(CollapsedAIEngineRow)
